"use strict";
exports.__esModule = true;
exports.openScreen = exports.navStackPop = exports.navigate = void 0;
var t = require("io-ts");
var createReqRes_1 = require("../request-handler/createReqRes");
var basic_1 = require("./util/basic");
var navigationAction = t.union([
    t.literal('POP'),
    t.literal('PUSH'),
    t.literal('REPLACE'),
]);
// Originating FROM either web or native
exports.navigate = (0, createReqRes_1.createReqRes)('navigate', t.type({
    url: t.string,
    action: t.union([t.undefined, navigationAction])
}), basic_1.genericStatusMessage);
exports.navStackPop = (0, createReqRes_1.createReqRes)('navigationStackPop', t.type({}), basic_1.genericStatusMessage);
// Origination FROM web
exports.openScreen = (0, createReqRes_1.createReqRes)('openScreen', t.type({
    screen: t.union([
        t.literal('notificationSettings'),
        t.literal('developerTools'),
    ])
}), basic_1.genericStatusMessage);
//# sourceMappingURL=navigation.js.map